import type { SVGProps } from "react";

export const BriefcaseIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className="fill-current"
      {...props}
    >
      <path
        d="M13.5 4.5C14.0967 4.5 14.6689 4.73722 15.0908 5.15918C15.5128 5.58114 15.75 6.15326 15.75 6.75V7.5H18C19.2426 7.5 20.25 8.50736 20.25 9.75V17.25C20.25 18.4926 19.2426 19.5 18 19.5H6C4.75736 19.5 3.75 18.4926 3.75 17.25V9.75C3.75 8.50736 4.75736 7.5 6 7.5H8.25V6.75C8.25 6.15326 8.48722 5.58114 8.90918 5.15918C9.33114 4.73722 9.90326 4.5 10.5 4.5H13.5ZM15.75 18H18C18.4142 18 18.75 17.6642 18.75 17.25V9.75C18.75 9.33579 18.4142 9 18 9H15.75V18ZM9.75 18H14.25V9H9.75V18ZM6 9C5.58579 9 5.25 9.33579 5.25 9.75V17.25C5.25 17.6642 5.58579 18 6 18H8.25V9H6ZM10.5 6C10.3011 6 10.1104 6.07907 9.96973 6.21973C9.82907 6.36038 9.75 6.55109 9.75 6.75V7.5H14.25V6.75C14.25 6.55109 14.1709 6.36038 14.0303 6.21973C13.9072 6.09668 13.7459 6.02098 13.5742 6.00391L13.5 6H10.5Z"
        fill="currentColor"
      />
    </svg>
  );
};
